"use strict";

var Term = 'Term';
var FormulaStrict = 'FormulaStrict';
var FormulaWithPrecedence = 'FormulaWithPrecedence';
var Clause = 'Clause';
var ITerm = 'ITerm';
var IClause = 'IClause';
var Constants = 'Constants';
var Predicates = 'Predicates';
var Functions = 'Functions';
var Domain = 'Domain';
var Tuples = 'Tuples';
var Valuation = 'Valuation';
var Substitution = 'Substitution';
var ISubstitution = 'ISubstitution';
module.exports = {
  Term: Term,
  FormulaStrict: FormulaStrict,
  FormulaWithPrecedence: FormulaWithPrecedence,
  Clause: Clause,
  ITerm: ITerm,
  IClause: IClause,
  Constants: Constants,
  Predicates: Predicates,
  Functions: Functions,
  Domain: Domain,
  Tuples: Tuples,
  Valuation: Valuation,
  Substitution: Substitution,
  ISubstitution: ISubstitution,
  'default': [Term, FormulaStrict, FormulaWithPrecedence, Clause, ITerm, IClause, Constants, Predicates, Functions, Domain, Tuples, Valuation, Substitution, ISubstitution]
};